import { type AxiosRequestConfig } from 'axios'

const addUserEducation = (data: any): AxiosRequestConfig => {
  return {
    method: 'POST',
    url: '/user/info/education/item',
    data
  }
}

export { addUserEducation }
